import './savingsAccountsOffersViewTableRow.scss';
// vendors
import React from 'react';
import PropTypes from 'prop-types';
// components
import OKTag from 'components/commons/OKTag/OKTag';
// helpers
import { getLastNChars } from 'utilities/stringHelper';
import { formatAmount, getCurrencyText, formatCurrency } from 'utilities/currencyHelper';

const SavingsAccountsOffersViewTableRow = ({ account, isLast }) => {
    const { catalogData, iban, balance, interventionType } = account;
    const accountName = `${catalogData.subtype} ${getLastNChars(iban)}`;

    const accountBalanceFormatted = formatAmount(balance.amount);
    const currency = balance.currency;
    const currencyFormatted = formatCurrency(currency);
    const currencyText = getCurrencyText(currency);
    const currencyId = `txt-AccountsBalanceCurrency-${currencyText}`;
    const isLastClass = isLast ? ' savings-table-row--last' : '';
    return (
        <tr className={`savings-table-row${isLastClass}`}>
            <td className="savings-table-row__alternative-color-cells">{accountName}</td>
            <td className="savings-table-row__right-cells">
                <OKTag content={`interventionTypes-${interventionType}`} context="arrow" />
            </td>
            <td className="savings-table-row__right-cells savings-table-row__right-cells--bold">
                <span>{accountBalanceFormatted}</span>&nbsp;
                <span id={currencyId}>{currencyFormatted}</span>
            </td>
        </tr>
    );
};

SavingsAccountsOffersViewTableRow.propTypes = {
    account: PropTypes.shape({
        catalogData: PropTypes.shape({
            subtype: PropTypes.string.isRequired,
        }).isRequired,
        iban: PropTypes.string.isRequired,
        balance: PropTypes.shape({
            amount: PropTypes.number.isRequired,
            currency: PropTypes.string.isRequired,
        }).isRequired,
        interventionType: PropTypes.string.isRequired,
    }).isRequired,
    isLast: PropTypes.bool,
};

export default SavingsAccountsOffersViewTableRow;